import { Injectable } from '@angular/core';
import { ProductsModule } from '../products.module';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CatalogService } from '../../../providers/services/catalog.service';
import { take, tap } from 'rxjs/operators';
import { SeoService } from '../../../providers/services/seo.service';

@Injectable({
  providedIn: ProductsModule
})
export class ProductResolverService implements Resolve<any> {

  constructor(private catalogService: CatalogService, private seoService: SeoService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.catalogService.getProduct(route.params.slug).pipe(take(1), tap(this.setSeo));
  }

  private setSeo = ({ body: { data: { product, links } } }) => {
    this.seoService.setTags(product.name, product.description_seo, product.image_header.path, links);
  }
}
